import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { NotificationBanner } from '@chegg-ui/notification-banner';
import { BannerLinkSC, ToastWrapperSC } from "./Toast.styles";
export var Toast = function Toast(props) {
  var variant = props.variant,
    title = props.title,
    message = props.message,
    isOpen = props.isOpen,
    ctaText = props.ctaText,
    ctaArg = props.ctaArg;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    firstRender = _useState2[0],
    setFirstRender = _useState2[1];
  useEffect(function () {
    if (isOpen && !firstRender) {
      // Note: intended to make a nice animation
      setFirstRender(true);
    }
  }, [isOpen]);
  if (!firstRender) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ToastWrapperSC, {
    fadeType: isOpen ? 'fadeIn' : 'fadeOut'
  }, /*#__PURE__*/React.createElement(NotificationBanner, {
    "data-test": "mfa_modal_banner",
    title: title,
    id: "mfa_modal_banner",
    bannerStyle: "global",
    type: variant,
    message: message,
    ctaLink: renderCta(ctaText)
  }));
  function renderCta(ctaText) {
    if (!ctaText) {
      return undefined;
    }
    return /*#__PURE__*/React.createElement(BannerLinkSC, {
      "data-test": "mfa_by_app_notification_link",
      onClick: ctaArg,
      size: "sm"
    }, ctaText);
  }
};